












































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { $eventsBus } from "@/main";
import MoveableOverlaysControlContainer from "@/app/modules/work/components/content-cotainer/preview-controls/MoveableOverlaysControlContainer.vue";
import BaseVideoRangeSlider from "@/app/shared/components/base/BaseVideoRangeSlider.vue";
import BaseVideoPackshotTimeline from "@/app/shared/components/base/BaseVideoPackshotTimeline.vue";
import BaseMediaTimeSlider from "@/app/shared/components/base/BaseMediaTimeSlider.vue";
import BaseVideo from "@/app/shared/components/base/BaseVideo.vue";
import BaseAnimationWithAudio from "@/app/shared/components/base/BaseAnimationWithAudio.vue";
import TheProportionalGridOverlay from "@/app/modules/work/components/content-cotainer/TheProportionalGridOverlay.vue"
import TheTikTokGridOverlay from "@/app/modules/work/components/content-cotainer/TheTikTokGridOverlay.vue"
import TheInstagramStoriesGridOverlay from "@/app/modules/work/components/content-cotainer/TheInstagramStoriesGridOverlay.vue"
import TheDropShadowSvgOverlay from "@/app/modules/work/components/content-cotainer/TheDropShadowSvgOverlay.vue"
import { ResizeObserver } from "vue-resize";
import { PreviewParameters } from "../../models/classes/PreviewParameters";
import utils from "@/app/shared/utils/utils.js";
import { EndCardAPI } from "../../services/EndCardAPI";
import BaseFiltered from "@/app/shared/components/base/BaseFiltered.vue";

export default Vue.extend({
  name: "PreviewContainer",
  components: {
    TheProportionalGridOverlay,
    TheTikTokGridOverlay,
    TheInstagramStoriesGridOverlay,
    TheDropShadowSvgOverlay,
    MoveableOverlaysControlContainer,
    BaseVideoRangeSlider,
    BaseVideoPackshotTimeline,
    BaseMediaTimeSlider,
    BaseVideo,
    ResizeObserver,
    BaseAnimationWithAudio,
    BaseFiltered,
  },
  mixins: [utils],
  data: function () {
    return {
      noUpdatePreset: false,
      noUpdateSize: false,
      tileFirstStyle: {
        width: "unset",
        height: "100%",
        left: "0px",
        top: "0px",
      },
      tileSecondStyle: {
        width: "unset",
        height: "100%",
        left: "0px",
        top: "0px",
      },
      tileFirstAdditionalStyle: {
        transform: null,
      },
      tileSecondAdditionalStyle: {
        transform: null,
      },
      mutedByMusicController: false,
      showVideoRangeSlider: false,
      showVideoPackshotTimeline: false,
      playingPackshot: false,
      movmentX: 0,
      lastMovmentWhenShiftByX: 0,
      movmentY: 0,
      lastMovmentWhenShiftByY: 0,
      changingDuration: false,
      changingContentTime: false,
      contentCurrentTime: 0,
      isAllPlaying: true,
      wasAllPlaying: false,
      isWasPlayingBeforeChanging: true,
      fit: {
        V: {
          height: 83.31,
          width: 100,
        },
        H: {
          height: 26.36,
          width: 100,
        },
        S: {
          height: 46.84,
          width: 100,
        },
        F: {
          height: 58.58,
          width: 100,
        },
        P: {
          height: 70.14,
          width: 100,
        },
      },
    };
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    isLoadingPackshot: function () {
      if (!this.previewItem.currentVariation.checked) {
        return this.previewItem.currentVariation.isLoadingPackshot;
      } else {
        return this.items.some((i) => {
          return i.variations.some((v) => {
            return v.checked && v.isLoadingPackshot;
          });
        });
      }
    },
    frontsideOverlays: function () {
      return this.items.reduce(
        (acc, val) =>
          acc.concat(
            val.variations.reduce(
              (accOverlays, valVariation) =>
                accOverlays.concat(
                  valVariation.overlays.map((s) => s).reverse()
                ),
              []
            )
          ),
        []
      );
    },
    backsideOverlays: function () {
      return this.items.reduce(
        (acc, val) =>
          acc.concat(
            val.variations.reduce(
              (accOverlays, valVariation) =>
                accOverlays.concat(
                  valVariation.overlaysOfBackside.map((s) => s).reverse()
                ),
              []
            )
          ),
        []
      );
    },
    previewItemZoom: function () {
      return this.$store.state.selectedItem.currentVariation.previewParameters
        .zoom;
    },
    previewItemPreset: function () {
      return this.$store.state.selectedItem.currentVariation.preset;
    },
    previewItemCurrentSize: function () {
      return this.$store.state.selectedItem.currentVariation.currentSize;
    },
    previewItemFullFilter: function () {
      return this.previewItem.currentVariation.getFullFilterAsString();
    },
    videoPreviewContainer: function () {
      return this.$refs.videoPreviewContainer;
    },
    muted: function () {
      return this.$store.state.muted;
    },
    checkedVariations: function () {
      return this.$store.state.items
        .reduce((acc, val) => acc.concat(val.variations), [])
        .filter((v) => v.checked);
    },
    videoSpeed: function () {
      return this.$store.state.selectedItem.currentVariation.speed;
    },
    isMultiSelectMode: function () {
      let checkedVariations = this.$store.state.items
        .reduce((acc, val) => acc.concat(val.variations), [])
        .filter((v) => v.checked);
      return (
        checkedVariations.length > 1 &&
        this.previewItem.currentVariation.checked
      );
    },
    isOriginalSize: function () {
      return this.previewItem.currentVariation.currentSize.title === "Original";
    },
    keymap: function () {
      return {
        "ctrl+left": this.swipeLeft,
        "command+left": (event) => {
          if (!event.metaKey) {
            return;
          }
          this.swipeLeft();
        },
        "ctrl+right": this.swipeRight,
        "command+right": (event) => {
          if (!event.metaKey) {
            return;
          }
          this.swipeRight();
        },
        space: {
          keyup: (event) => {
            if (document.activeElement.tagName === 'INPUT') {
              return
            }
            if (this.$store.getters.showRendersPreviewWindow) {
              return;
            }
            this.isAllPlaying = !this.isAllPlaying;
          },
        },
      };
    },
    contentVideoCurrentTime: {
      // getter
      get: function () {
        return this.$store.state.contentVideoCurrentTime;
      },
      // setter
      set: function (newValue) {
        this.$store.commit("contentVideoCurrentTime", newValue);
        this.updateContentCurrentTime();
      },
    },
    contentAllTime: function () {
      let currentVariation = this.previewItem.currentVariation;
      let videoTime =
        (currentVariation.cut.finishTime - currentVariation.cut.startTime) /
        currentVariation.speed;
      return (
        videoTime +
        currentVariation.endCard.getDuration(
          this.previewItem.currentVariation.currentSize.name.toLowerCase()
        )
      );
    },

    shadowParameters: function () {
      return this.$store.getters.getShadowForCurrentVariation
    },

    openedGridType: function () {
      return this.$store.getters.getOpenedGridType
    },
  },
  mounted() {
    if (this.previewItem.currentVariation.preset.name === "slicer") {
      this.updatePreview(true);
    }
    this.$store.commit(
      "videoPreviewPixelsWidth",
      this.$refs.videoPreviewContainer.getBoundingClientRect().width
    );

    $eventsBus.$on("updateAnimationPackshot", (endCard) => {
      this.updateAnimationPackshot(endCard);
    });
  },
  created() {
    $eventsBus.$on("stopPlayContent", () => {
      this.playContent(false);
      this.setContentTime(this.previewItem.currentVariation.cut.startTime);
    });
    $eventsBus.$on("changePreviewTime", (time) => {
      this.setContentTime(time);
    });
    $eventsBus.$on("startPlayContent", (startTime) => {
      this.setContentTime(startTime);
      this.playContent(true);
    });
    $eventsBus.$on("muteMainContent", (isMute) => {
      this.mutedByMusicController = isMute;
      this.muteMusic(isMute || this.muted);
    });
    $eventsBus.$on("showVideoRangeSlider", (isShow) => {
      this.showVideoRangeSlider = isShow;
    });
    $eventsBus.$on("showVideoPackshotTimeline", (isShow) => {
      this.showVideoPackshotTimeline = isShow;
    });
    $eventsBus.$on("updatePackshotAfterChanges", () => {
      this.updatePackshotAfterChanges();
    });
  },
  watch: {
    muted: function () {
      this.muteMusic(this.mutedByMusicController || this.muted);
    },
    "previewItem.currentVariation": {
      deep: true,
      handler() {
        this.muteMusic(
          this.mutedByMusicController || this.muted || this.playingPackshot
        );
        this.updateContentsVolume();
        setTimeout(() => {
          this.checkAndUpdateTile();
        }, 10);
      },
    },
    "previewItem.currentVariation.id": function () {
      this.updatePreview(true);
      this.stopPackshotAndPlayContent();
      this.setContentTime(this.previewItem.currentVariation.cut.startTime);
    },
    previewItem: function () {
      //this.noUpdatePreset = true;
      //this.noUpdateSize = true;
      this.updatePreview(true);
      this.stopPackshotAndPlayContent();
      this.setContentTime(this.previewItem.currentVariation.cut.startTime);
    },
    previewItemPreset: function () {
      if (this.noUpdatePreset) {
        this.noUpdatePreset = false;
        return;
      }
      this.updatePreview(true);
      if (
        this.previewItem.currentVariation.preset.name === "blur" ||
        this.previewItem.currentVariation.preset.name === "tile"
      ) {
        /*         this.$refs.firstVideo.pause();
        this.$refs.secondVideo.pause();
        this.$refs.backsideTileFirstStyleVideo.pause();
        this.$refs.backsideTileSecondVideo.pause();
        this.$refs.secondVideo.currentTime = this.$refs.firstVideo.currentTime;
        this.$refs.backsideTileFirstStyleVideo.currentTime = this.$refs.firstVideo.currentTime;
        this.$refs.backsideTileSecondVideo.currentTime = this.$refs.firstVideo.currentTime;
        this.$refs.secondVideo.play();
        this.$refs.backsideTileFirstStyleVideo.play();
        this.$refs.backsideTileSecondVideo.play();
		this.$refs.firstVideo.play(); */
        //this.syncBacksideVideos();
        this.setContentTime(this.previewItem.currentVariation.cut.startTime);
      }
    },
    previewItemCurrentSize: function () {
      if (this.noUpdateSize) {
        this.noUpdateSize = false;
        return;
      }

      this.updatePreview(true);

      this.stopPackshotAndPlayContent();
      this.setContentTime(this.contentVideoCurrentTime);
      this.playContent(true);
    },
    previewItemZoom: function () {
      let itemParameters = this.previewItem.currentVariation.previewParameters;
      var disHorSh = itemParameters.displayHorizontalShift;
      var disVerSh = itemParameters.displayVerticalShift;
      this.updatePreview(false);
      itemParameters.displayHorizontalShift =
        itemParameters.displayMaxHorizontalShift === 0 ? 0 : disHorSh;
      itemParameters.displayVerticalShift =
        itemParameters.displayMaxVerticalShift === 0 ? 0 : disVerSh;
      this.previewItem.currentVariation.shiftVideoPreview(
        this.previewItem.currentVariation.getShiftByDisplayShift(true),
        this.previewItem.currentVariation.getShiftByDisplayShift(false)
      );
    },
    videoSpeed: function () {
      this.checkAndUpdateSpeed();
      this.updateContentCurrentTime();
    },
    isAllPlaying: function () {
      if (this.isAllPlaying) {
        if (this.playingPackshot) {
          this.playPackshot();
        } else {
          this.playContent(true);
        }
        let audio = this.$refs.music;
        if (audio && audio.paused) {
          const promisePlay = audio.play();
          if(promisePlay !== undefined){
            promisePlay.then(() => {
              // Autoplay started
            }).catch(error => {
              // Autoplay was prevented.
            });
          }
        }
      } else {
        this.playContent(false);
        this.pausePackshot();
        let audio = this.$refs.music;
        if (audio) {
          audio.pause();
        }
      }
    },
    isLoadingPackshot: function () {
      if (this.isLoadingPackshot) {
        this.isAllPlaying = false;
      }
    },
  },
  methods: {
    canvasInitHandler() {
      console.log('canvas inited')
      this.playContent(false)
      this.changeContentTime(0)
    },
    playButtonEventHandler(played) {
      this.playContent(played)
    },
    timelineChangeTimeEventHandler(newTime) {
      this.changeContentTime(newTime)
    },
    recalcSharpen() {
      if (!!this.$refs.firstVideo) {
        return (
          (this.previewItemFullFilter.sharpen *
            this.$refs.firstVideo.getBoundingClientRect().width) /
          this.previewItem.innerVideoResolutionX
        );
      }
      return this.previewItemFullFilter.sharpen;
    },
    updatePackshotAfterChanges() {
      this.updatePreview(true);
      this.stopPackshotAndPlayContent();
      this.setContentTime(this.previewItem.currentVariation.cut.startTime);
    },
    updateAnimationPackshot(endCard) {
      // Костыль для игнорирования ошибки отрисовки (Не находится ref анимации c первого раза)
      if (
        !this.$refs.firstPackshotTemplate ||
        endCard.getType() !== "template-default"
      ) {
        return null;
      }

      this.$refs.firstPackshotTemplate.updateAnimation();
    },
    isPackhotTypeVideo() {
      return (
        this.previewItem.currentVariation.endCard.packshot &&
        this.previewItem.currentVariation.endCard.packshot.type === "video"
      );
    },
    isPackhotTypeTemplate() {
      return (
        this.previewItem.currentVariation.endCard.packshot &&
        this.previewItem.currentVariation.endCard.packshot.type ===
          "template-default"
      );
    },
    playPackshot() {
      if (this.isPackhotTypeVideo()) {
        this.$refs.firstPackshotVideo.play();
      } else if (this.isPackhotTypeTemplate()) {
        // Костыль для игнорирования ошибки отрисовки (Не находится ref анимации c первого раза)
        if (!this.$refs.firstPackshotTemplate) {
          return null;
        }
        this.$refs.firstPackshotTemplate.goToAndPlay();
      }
    },
    pausePackshot() {
      if (this.isPackhotTypeVideo()) {
        this.$refs.firstPackshotVideo.pause();
      } else if (this.isPackhotTypeTemplate()) {
        // Костыль для игнорирования ошибки отрисовки (Не находится ref анимации c первого раза)
        if (!this.$refs.firstPackshotTemplate) {
          return null;
        }
        this.$refs.firstPackshotTemplate.goToAndStop();
      }
    },
    getCurrentTimePackshot() {
      if (this.isPackhotTypeVideo()) {
        return this.$refs.firstPackshotVideo.currentTime;
      } else if (
        this.isPackhotTypeTemplate() &&
        this.$refs.firstPackshotTemplate &&
        this.$refs.firstPackshotTemplate.getCurrentFrame()
      ) {
        return (
          this.$refs.firstPackshotTemplate.getCurrentFrame() /
          this.previewItem.currentVariation.endCard.getAnimationPropAtPath(
            this.previewItem.currentVariation.endCard.packshot.model.fps.path
          )
        );
      } else return 0;
    },
    setCurrentTimePackshot(currentTime) {
      if (this.isPackhotTypeVideo()) {
        this.$refs.firstPackshotVideo.currentTime = currentTime;
      } else if (this.isPackhotTypeTemplate()) {
        // Костыль для игнорирования ошибки отрисовки (Не находится ref анимации c первого раза)
        if (!this.$refs.firstPackshotTemplate) {
          return null;
        }
        this.$refs.firstPackshotTemplate.goToAndStop(currentTime * 1000);
      }
    },
    onResize() {
      this.resizeUpdater();
    },
    swipeLeft() {
      if (
        this.checkedVariations.length <= 1 ||
        !this.previewItem.currentVariation.checked ||
        this.$store.getters.showRendersPreviewWindow
      ) {
        return;
      }
      let itemIndex = this.checkedVariations.indexOf(
        this.previewItem.currentVariation
      );
      let leftIndex =
        itemIndex === 0 ? this.checkedVariations.length - 1 : itemIndex - 1;
      let currentPreview = this.checkedVariations[leftIndex];
      let currentPreviewParentItem = this.items.find(
        (item) => item.id === currentPreview.parentItem.id
      );
      currentPreviewParentItem.currentVariation = currentPreview;
      this.$store.commit("changeSelectItem", currentPreviewParentItem);

      $eventsBus.$emit("scrollToTopToolsPanel");
    },
    swipeRight() {
      if (
        this.checkedVariations.length <= 1 ||
        !this.previewItem.currentVariation.checked ||
        this.$store.getters.showRendersPreviewWindow
      ) {
        return;
      }
      let itemIndex = this.checkedVariations.indexOf(
        this.previewItem.currentVariation
      );
      let rightIndex =
        itemIndex === this.checkedVariations.length - 1 ? 0 : itemIndex + 1;
      let currentPreview = this.checkedVariations[rightIndex];
      let currentPreviewParentItem = this.items.find(
        (item) => item.id === currentPreview.parentItem.id
      );
      currentPreviewParentItem.currentVariation = currentPreview;
      this.$store.commit("changeSelectItem", currentPreviewParentItem);

      $eventsBus.$emit("scrollToTopToolsPanel");
    },
    onStartDragVideo(event) {
      if (
        this.playingPackshot ||
        (this.isOriginalSize && this.previewItem.isOutsize) ||
        (!this.isOriginalSize &&
          this.previewItem.currentVariation.preset.name === "tile")
      ) {
        return;
      }
      this.movmentX = 0;
      this.movmentY = 0;
      this.lastMovmentWhenShiftByX = 0;
      this.lastMovmentWhenShiftByY = 0;
      this.wasAllPlaying = this.isAllPlaying;

      if (this.wasAllPlaying) {
        this.playContent(false);
      }
      window.onmousemove = this.moveVideoAt.bind(event);
      window.onmouseup = this.stopDragVideo.bind(event);
    },
    moveVideoAt(event) {
      event.preventDefault();
      this.movmentX += event.movementX;
      this.movmentY += event.movementY;
      let stepX =
        this.$refs.firstVideo.getBoundingClientRect().width /
        (2 * PreviewParameters.CONSTANT_MAX_DISPLAY_SHIFT_VALUE);
      let stepY =
        this.$refs.firstVideo.getBoundingClientRect().height /
        (2 * PreviewParameters.CONSTANT_MAX_DISPLAY_SHIFT_VALUE);
      if (this.movmentX - this.lastMovmentWhenShiftByX > stepX) {
        this.lastMovmentWhenShiftByX = this.movmentX;
        $eventsBus.$emit("shiftVideoByOneStep", "move-right", true);
      } else if (this.movmentX - this.lastMovmentWhenShiftByX < -stepX) {
        this.lastMovmentWhenShiftByX = this.movmentX;
        $eventsBus.$emit("shiftVideoByOneStep", "move-left", true);
      }
      if (this.movmentY - this.lastMovmentWhenShiftByY < -stepY) {
        this.lastMovmentWhenShiftByY = this.movmentY;
        $eventsBus.$emit("shiftVideoByOneStep", "move-up", true);
      } else if (this.movmentY - this.lastMovmentWhenShiftByY > stepY) {
        this.lastMovmentWhenShiftByY = this.movmentY;
        $eventsBus.$emit("shiftVideoByOneStep", "move-down", true);
      }
    },
    stopDragVideo(event) {
      if (this.wasAllPlaying) {
        this.playContent(true);
      }

      this.$store.commit("addNewStateToHistory");
      window.onmouseup = null;
      window.onmousemove = null;
    },
    startDrag(side) {
      this.playingPackshot = false;
      this.changingDuration = true;
      this.playContent(false);
      this.setContentTime(
        side === "left"
          ? this.previewItem.currentVariation.cut.startTime
          : this.previewItem.currentVariation.cut.finishTime
      );
    },
    changeDuration(time) {
      this.previewItem.currentVariation.checkAndUpdateMusicTime();
      //this.previewItem.currentVariation.checkAndUpdateWatermarkTime();
      //this.previewItem.currentVariation.checkAndUpdateStickersTime();
      //this.previewItem.currentVariation.checkAndUpdateOverlayVideoTime();
      //this.previewItem.currentVariation.checkAndUpdateTextTime();
      $eventsBus.$emit("changePreviewTime", time);
      this.previewItem.currentVariation.recalcFileOutputParameters();
    },
    stopDrag(startTime) {
      // $eventsBus.$emit("startPlayContent", startTime);
      this.changingDuration = false;
      this.$store.commit("addNewStateToHistory");
    },
    updateContentCurrentTime() {
      let currentVariation = this.previewItem.currentVariation;
      if (currentVariation.endCard.packshot && this.playingPackshot) {
        this.contentCurrentTime =
          (currentVariation.cut.finishTime - currentVariation.cut.startTime) /
            currentVariation.speed +
          this.getCurrentTimePackshot();
      } else {
        this.contentCurrentTime =
          (this.$refs.firstVideo.getCurrentTime() -
            currentVariation.cut.startTime) /
          currentVariation.speed;
      }
    },
    startChangeContentTime() {
      this.isWasPlayingBeforeChanging = this.isAllPlaying;
      this.playContent(false);
      if (this.$refs.firstPackshotVideo || this.$refs.firstPackshotTemplate) {
        this.pausePackshot();
      }
      this.changingContentTime = true;
      this.isAllPlaying = false;
    },
    changeContentTime(time) {
      let isPlayingNow = this.isAllPlaying;
      let videoTime =
        (this.previewItem.currentVariation.cut.finishTime -
          this.previewItem.currentVariation.cut.startTime) /
        this.previewItem.currentVariation.speed;
      if (time > videoTime) {
        if (!this.previewItem.currentVariation.endCard.packshot) {
          return;
        }
        this.playingPackshot = true;
        this.playContent(false);
        if (!this.previewItem.currentVariation.music.isExtendToEndCard) {
          this.muteMusic(true);
        }
        this.setCurrentTimePackshot(time - videoTime);
        if (this.changingContentTime) {
          this.pausePackshot();
        } else if (isPlayingNow) {
          this.playPackshot();
          this.isAllPlaying = true;
        }
        this.setContentTime(0);
      } else {
        let timeToSet =
          time * this.previewItem.currentVariation.speed +
          this.previewItem.currentVariation.cut.startTime;
        if (this.previewItem.currentVariation.endCard.packshot) {
          this.playingPackshot = false;
          this.pausePackshot();
          this.setCurrentTimePackshot(0);
        }
        this.setContentTime(timeToSet);
        if (!this.changingContentTime && isPlayingNow) {
          this.playContent(true);
        }
      }
    },
    stopChangeContentTime() {
      if (this.isWasPlayingBeforeChanging) {
        if (this.playingPackshot) {
          if (this.$refs.firstPackshotVideo) {
            this.playPackshot();
          }
        } else {
          this.playContent(true);
        }
        this.isAllPlaying = true;
      }
      this.changingContentTime = false;
    },
    resizeParent() {
      var o = this.$refs.workBlock;
      //o.style.height = this.$refs.image.offsetHeight + 10 + "px";
      o.style.width = this.$refs.image.offsetWidth + "px";
    },
    syncBacksideVideos() {
      let ct = !this.$refs.firstVideo.isRendered()
        ? 0
        : this.$refs.firstVideo.getCurrentTime();
      if (
        this.$refs.backsideTileFirstStyleVideo.isRendered() &&
        Math.abs(this.$refs.backsideTileFirstStyleVideo.getCurrentTime() - ct) >
          0.5
      ) {
        this.$refs.backsideTileFirstStyleVideo.setCurrentTime(ct);
      }
      if (
        this.$refs.backsideTileSecondVideo.isRendered() &&
        Math.abs(this.$refs.backsideTileSecondVideo.getCurrentTime() - ct) > 0.5
      ) {
        this.$refs.backsideTileSecondVideo.setCurrentTime(ct);
      }
      if (
        this.$refs.secondVideo.isRendered() &&
        Math.abs(this.$refs.secondVideo.getCurrentTime() - ct) > 0.5
      ) {
        this.$refs.secondVideo.setCurrentTime(ct);
      }
    },
    playContent(isPlay) {
      if (isPlay) {
        this.$refs.firstVideo.play();
        this.$refs.secondVideo.play();
        this.$refs.backsideTileFirstStyleVideo.play();
        this.$refs.backsideTileSecondVideo.play();
        this.isAllPlaying = true;
      } else {
        this.$refs.firstVideo.pause();
        this.$refs.secondVideo.pause();
        this.$refs.backsideTileFirstStyleVideo.pause();
        this.$refs.backsideTileSecondVideo.pause();
        this.isAllPlaying = false;
      }
    },
    muteMusic(isMute) {
      let audio = this.$refs.music;
      if (audio) {
        audio.muted = isMute;
      }
    },
    updateContentsVolume() {
      let audio = this.$refs.music;
      if (
        audio &&
        audio.volume !== this.previewItem.currentVariation.music.volume
      ) {
        audio.volume = this.previewItem.currentVariation.music.volume;
      }

      if (
        this.$refs.firstVideo.isRendered() &&
        this.$refs.firstVideo.getVolume() !==
          this.previewItem.currentVariation.volume
      ) {
        this.$refs.firstVideo.setVolume(
          this.previewItem.currentVariation.volume
        );
      }
      let packshot = this.$refs.firstPackshotVideo;
      if (
        packshot &&
        packshot.volume !== this.previewItem.currentVariation.endCard.volume
      ) {
        packshot.volume = this.previewItem.currentVariation.endCard.volume;
      }
    },
    setMusicTime(time) {
      let audio = this.$refs.music;
      if (audio && audio.currentTime !== time) {
        audio.currentTime = time;
      }
    },
    setContentTime(videoTime) {
      this.$refs.firstVideo && this.$refs.firstVideo.setCurrentTime(videoTime);
      this.$refs.secondVideo &&
        this.$refs.secondVideo.setCurrentTime(videoTime);
      this.$refs.backsideTileFirstStyleVideo &&
        this.$refs.backsideTileFirstStyleVideo.setCurrentTime(videoTime);
      this.$refs.backsideTileSecondVideo &&
        this.$refs.backsideTileSecondVideo.setCurrentTime(videoTime);
      this.contentVideoCurrentTime = videoTime;
    },
    checkAndUpdateSpeed() {
      if (
        this.$refs.firstVideo.isRendered() &&
        this.$refs.firstVideo.getPlaybackRate() !== this.videoSpeed
      ) {
        this.$refs.firstVideo.setPlaybackRate(this.videoSpeed);
        this.$refs.secondVideo.setPlaybackRate(this.videoSpeed);
        this.$refs.backsideTileFirstStyleVideo.setPlaybackRate(this.videoSpeed);
        this.$refs.backsideTileSecondVideo.setPlaybackRate(this.videoSpeed);
      }
    },
    stopPackshotAndPlayContent() {
      this.playingPackshot = false;
      this.playContent(true);
      this.setCurrentTimePackshot(0);
      this.pausePackshot();
    },
    stopContentAndPlayPackshot() {
      if (!this.previewItem.currentVariation.endCard.packshot) {
        return;
      }
      this.playingPackshot = true;
      this.playContent(false);
      if (!this.previewItem.currentVariation.music.isExtendToEndCard) {
        this.muteMusic(true);
      }
      this.setCurrentTimePackshot(0);
      //this.$refs.secondPackshotVideo.currentTime = 0;
      this.playPackshot();
      //this.$refs.secondPackshotVideo.play();
      this.isAllPlaying = true;
    },
    checkAndUpdateTime() {
      this.updateContentsVolume();
      this.muteMusic(
        this.mutedByMusicController ||
          this.muted ||
          (this.playingPackshot &&
            !this.previewItem.currentVariation.music.isExtendToEndCard)
      );
      if (
        !this.$refs.firstVideo.isRendered() ||
        !this.previewItem ||
        !this.isAllPlaying
      ) {
        return;
      }
      let cut = this.previewItem.currentVariation.cut;
      /*       if (
        Math.abs(
          this.contentVideoCurrentTime - this.$refs.firstVideo.getCurrentTime()
        ) > 0.2 &&
        !this.changingDuration &&
        !this.changingContentTime
      ) {
        this.contentVideoCurrentTime = this.$refs.firstVideo.getCurrentTime();
        if (!this.playingPackshot || this.$refs.firstPackshotVideo.paused) {
          this.stopContentAndPlayPackshot();
        }
        return;
      } */
      if (
        !this.$refs.firstVideo.isPaused() &&
        !this.changingDuration &&
        !this.changingContentTime &&
        (this.$refs.firstVideo.getCurrentTime() - cut.finishTime >= -0.05 ||
          this.$refs.firstVideo.getCurrentTime() - cut.startTime <= 0)
      ) {
        if (!!this.previewItem.currentVariation.endCard.packshot) {
          this.$refs.firstVideo.pause();
          if (!this.playingPackshot || this.$refs.firstPackshotVideo.paused) {
            this.stopContentAndPlayPackshot();
          }
        }
        if (this.$refs.firstVideo.getCurrentTime() !== cut.startTime) {
          this.setContentTime(cut.startTime);
        }
        //this.setMusicTime(0);
      } else {
        this.contentVideoCurrentTime = this.$refs.firstVideo.getCurrentTime();
        let audio = this.$refs.music;
        if (audio) {
          let musicDurationFromMusicStartTime =
            this.previewItem.currentVariation.music.file.duration +
            this.previewItem.currentVariation.music.startTime / this.videoSpeed;
          //if (!this.playingPackshot) {
          if (
            this.$refs.firstVideo.getCurrentTime() /* / this.videoSpeed */ -
              this.previewItem.currentVariation.music.startTime <
              0 ||
            musicDurationFromMusicStartTime <=
              this.$refs.firstVideo.getCurrentTime() / this.videoSpeed
          ) {
            audio.pause();
            return;
          } else {
            if (audio.paused) {
              const promisePlay = audio.play();
              if(promisePlay !== undefined){
                promisePlay.then(() => {
                  // Autoplay started
                }).catch(error => {
                  // Autoplay was prevented.
                });
              }
            }
          }
          if (
            Math.abs(
              audio.currentTime -
                (this.$refs.firstVideo.getCurrentTime() -
                  this.previewItem.currentVariation.music.startTime) /
                  this.videoSpeed
            ) > 0.2
          ) {
            audio.currentTime =
              (this.$refs.firstVideo.getCurrentTime() -
                this.previewItem.currentVariation.music.startTime) /
              this.videoSpeed;
          }
        }
      }
    },
    onPackshotTimeUpdate() {
      if (!this.playingPackshot) {
        return;
      }
      this.updateContentCurrentTime();
      this.updateContentsVolume();
      this.tryAnimateEndCardTransition();
      this.muteMusic(
        this.mutedByMusicController ||
          this.muted ||
          (this.playingPackshot &&
            !this.previewItem.currentVariation.music.isExtendToEndCard)
      );
      let audio = this.$refs.music;
      if (
        !this.$refs.firstVideo.isRendered() ||
        !this.previewItem ||
        !this.previewItem.currentVariation.music.isExtendToEndCard ||
        !audio
      ) {
        return;
      }
      let cut = this.previewItem.currentVariation.cut;
      let playedTime =
        (cut.finishTime - this.previewItem.currentVariation.music.startTime) /
        this.videoSpeed;

      if (this.isAllPlaying) {
        if (audio.paused) {
          const promisePlay = audio.play();
          if(promisePlay !== undefined){
            promisePlay.then(() => {
              // Autoplay started
            }).catch(error => {
              // Autoplay was prevented
            });
          }
        }
      } else {
        audio.pause();
      }
      if (
        Math.abs(
          audio.currentTime - (this.getCurrentTimePackshot() + playedTime)
        ) > 0.2
      ) {
        audio.currentTime = this.getCurrentTimePackshot() + playedTime;
      }
    },
    checkAndUpdateTile() {
      if (
        this.previewItem.currentVariation.preset.name !== "tile" ||
        !this.$refs.videoPreviewContainer
      ) {
        return;
      }
      let previewContainerRect =
        this.$refs.videoPreviewContainer.getBoundingClientRect();
      let videoRect = this.$refs.firstVideo.getBoundingClientRect();
      let isWidthScaled =
        videoRect.width / videoRect.height <=
        previewContainerRect.width / previewContainerRect.height;

      this.tileFirstStyle.left = isWidthScaled
        ? "calc(0% - " +
          (videoRect.width -
            1 -
            (previewContainerRect.width - videoRect.width) / 2) +
          "px)"
        : "0px";
      this.tileFirstStyle.top = isWidthScaled
        ? "0px"
        : "calc(0% - " +
          (videoRect.height -
            1 -
            (previewContainerRect.height - videoRect.height) / 2) +
          "px)";
      this.tileFirstStyle.width = isWidthScaled
        ? `${
            (previewContainerRect.height /
              previewContainerRect.width /
              videoRect.height) *
            videoRect.width *
            100
          }%`
        : "100%";
      this.tileFirstStyle.height = isWidthScaled
        ? "100%"
        : `${
            (previewContainerRect.width /
              previewContainerRect.height /
              videoRect.width) *
            videoRect.height *
            100
          }%`;
      /*       this.tileFirstStyle.transform = isWidthScaled
        ? "scale(-1, 1)"
        : "scale(1, -1)"; */

      this.tileSecondStyle.left = isWidthScaled
        ? "calc(0% + " +
          (videoRect.width -
            2 +
            (previewContainerRect.width - videoRect.width) / 2) +
          "px)"
        : "0px";
      this.tileSecondStyle.top = isWidthScaled
        ? "0px"
        : "calc(0% + " +
          (videoRect.height -
            2 +
            (previewContainerRect.height - videoRect.height) / 2) +
          "px)";
      this.tileSecondStyle.width = isWidthScaled
        ? `${
            (previewContainerRect.height /
              previewContainerRect.width /
              videoRect.height) *
            videoRect.width *
            100
          }%`
        : "100%";
      this.tileSecondStyle.height = isWidthScaled
        ? "100%"
        : `${
            (previewContainerRect.width /
              previewContainerRect.height /
              videoRect.width) *
            videoRect.height *
            100
          }%`;
      /*       this.tileSecondStyle.transform = isWidthScaled
        ? "scale(-1, 1)"
        : "scale(1, -1)"; */

      let transform = "";
      let isFlipHor = this.previewItem.currentVariation.flipHorizontal;
      let isFlipVer = this.previewItem.currentVariation.flipVertical;
      if (isWidthScaled) {
        transform =
          (isFlipHor ? "scaleX(1) " : "scaleX(-1) ") +
          (isFlipVer ? "scaleY(-1) " : "scaleY(1) ");
      } else {
        transform =
          (isFlipHor ? "scaleX(-1) " : "scaleX(1) ") +
          (isFlipVer ? "scaleY(1) " : "scaleY(-1) ");
      }
      if (
        this.tileFirstAdditionalStyle.transform !== transform ||
        this.tileSecondAdditionalStyle.transform !== transform
      ) {
        this.tileFirstAdditionalStyle.transform = transform;
        this.tileSecondAdditionalStyle.transform = transform;
        this.$forceUpdate();
      }
    },
    onTimeUpdate() {
      if (!this.previewItem) {
        return;
      }
      this.checkAndUpdateSpeed();
      this.checkAndUpdateTime();
      this.tryAnimateEndCardTransition();
      if (
        this.previewItem.currentVariation.preset.name === "tile" ||
        this.previewItem.currentVariation.preset.name === "blur"
      ) {
        this.syncBacksideVideos();
      }
      this.checkAndUpdateTile();
    },
    updatePreview(isRecalc) {
      if (isRecalc) {
        this.previewItem.currentVariation.recalcOuterVideoResolutions();
      }
      this.previewItem.currentVariation.calcVideoPreviewPositon(
        this.previewItem.currentVariation.preset.name
      );
      setTimeout(() => {
        let videoDiv = this.$refs.videoPreviewContainer.getBoundingClientRect();
        this.previewItem.currentVariation.recalcCropsParams(videoDiv.width);
      }, 4);
    },
    resizeUpdater() {
      console.log("resize");
      this.resizeParent();
      this.updatePreview(false);
      this.$store.commit(
        "videoPreviewPixelsWidth",
        this.$refs.videoPreviewContainer.getBoundingClientRect().width
      );
    },
    openEndCardLibraryWindow() {
      this.$store.commit("showEndCardLibraryWindow", true);
    },
    trashCurrentEndCard() {
      this.previewItem.currentVariation.endCard.packshot = null;
      this.previewItem.currentVariation.recalcFileOutputParameters();
    },
    tryAnimateEndCardTransition() {
      let mainVideo = this.$refs.mainVideoContainer;
      let mainVideoBackside = this.$refs.mainVideoBacksideContainer;
      let packshotVideo = this.isPackhotTypeVideo()
        ? this.$refs.packshotVideoContainer
        : this.$refs.packshotTemplateContainer;

      if (!this.previewItem.currentVariation.endCard.packshot) {
        mainVideo.style.transition = "none";
        mainVideo.style.opacity = 1;
        mainVideo.style.transform = "translateX(0%) translateY(0%)";
        mainVideoBackside.style.transition = mainVideo.style.transition;
        mainVideoBackside.style.opacity = mainVideo.style.opacity;
        mainVideoBackside.style.transform = mainVideo.style.transform;
        packshotVideo.style.transition = "none";
        packshotVideo.style.opacity = 0;
        packshotVideo.style.transform = "translateX(0%) translateY(0%)";
        return;
      }
      let transitionStyleId =
        this.previewItem.currentVariation.endCard.transitionStyleId;
      let animateNow =
        this.previewItem.currentVariation.cut.finishTime -
          this.$refs.firstVideo.getCurrentTime() <=
        0.3;
      let translateMain = "translateX(100%)";
      let translatePackshot = "translateX(-100%)";
      let isMotion = false;
      let isBlurMotion = false;
      switch (transitionStyleId) {
        // motionCut
        case 0:
          mainVideo.style.transition = "none";
          mainVideo.style.opacity = this.playingPackshot ? 0 : 1;
          mainVideo.style.transform = "translateX(0%) translateY(0%)";
          packshotVideo.style.opacity = this.playingPackshot ? 1 : 0;
          break;
        // motionAlpha
        case 1:
          mainVideo.style.transition =
            animateNow && !this.playingPackshot
              ? "opacity 0.3s ease-in"
              : "none";
          mainVideo.style.opacity = animateNow || this.playingPackshot ? 0 : 1;
          mainVideo.style.transform = "translateX(0%) translateY(0%)";
          packshotVideo.style.transition =
            animateNow || this.playingPackshot
              ? "opacity 0.3s ease-in"
              : "none";
          packshotVideo.style.opacity =
            animateNow || this.playingPackshot ? 1 : 0;
          packshotVideo.style.transform = "translateX(0%) translateY(0%)";
          break;
        // motionLeft
        case 2:
        // motionLeftBlur
        case 5:
          isMotion = transitionStyleId === 2;
          isBlurMotion = transitionStyleId === 5;
          translateMain = "translateX(-100%)";
          translatePackshot = "translateX(100%)";
          break;
        // motionRight
        case 3:
        // motionRightBlur
        case 4:
          isMotion = transitionStyleId === 3;
          isBlurMotion = transitionStyleId === 4;
          translateMain = "translateX(100%)";
          translatePackshot = "translateX(-100%)";
          break;
        // motionUp
        case 6:
        // motionUpBlur
        case 8:
          isMotion = transitionStyleId === 6;
          isBlurMotion = transitionStyleId === 8;
          translateMain = "translateY(-100%)";
          translatePackshot = "translateY(100%)";
          break;
        // motionDown
        case 7:
        // motionDownBlur
        case 9:
          isMotion = transitionStyleId === 7;
          isBlurMotion = transitionStyleId === 9;
          translateMain = "translateY(100%)";
          translatePackshot = "translateY(-100%)";
          break;
        default:
          break;
      }
      if (isMotion) {
        //Motions
        mainVideo.style.transition =
          this.playingPackshot || !animateNow
            ? "none"
            : "transform 0.3s ease-in, opacity 0.3s ease-in";
        mainVideo.style.transform =
          animateNow && !this.playingPackshot
            ? translateMain
            : "translateX(0%) translateY(0%)";
        mainVideo.style.opacity = this.playingPackshot ? 0 : 1;
        packshotVideo.style.transition =
          "transform 0.3s ease-in, opacity 0s ease-in";
        packshotVideo.style.transform =
          animateNow || this.playingPackshot
            ? "translateX(0%) translateY(0%)"
            : translatePackshot;
        packshotVideo.style.opacity =
          animateNow || this.playingPackshot ? 1 : 0;
      } else if (isBlurMotion) {
        //Motions with blur
        mainVideo.style.transition =
          this.playingPackshot || !animateNow
            ? "none"
            : "transform 0.3s cubic-bezier(.4,.42,.74,.45), opacity 0.5s ease-in";
        mainVideo.style.filter = animateNow ? "blur(2px)" : "none";
        mainVideo.style.transform =
          animateNow && !this.playingPackshot
            ? translateMain
            : "translateX(0%) translateY(0%)";
        mainVideo.style.opacity = this.playingPackshot ? 0 : 1;
        packshotVideo.style.transition =
          "transform 0.3s cubic-bezier(.4,.42,.74,.45), opacity 0s ease-in";
        packshotVideo.style.transform =
          animateNow || this.playingPackshot
            ? "translateX(0%) translateY(0%)"
            : translatePackshot;
        packshotVideo.style.opacity =
          animateNow || this.playingPackshot ? 1 : 0;
        packshotVideo.style.filter = animateNow ? "blur(2px)" : "none";
      }
      mainVideoBackside.style.transition = mainVideo.style.transition;
      mainVideoBackside.style.opacity = mainVideo.style.opacity;
      mainVideoBackside.style.transform = mainVideo.style.transform;
    },
  },
});
